import { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const handleCategoryClick = (slug: string) => {
    navigate(`/category/${slug}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-lg text-background-50"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
              韩漫网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').slice(0, 5).map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700 hover:bg-background-100 hover:text-foreground-950'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <button
              onClick={() => handleCategoryClick('all')}
              className="px-3 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-100 hover:text-foreground-950 transition-colors whitespace-nowrap"
            >
              更多 <i className="ri-arrow-down-s-line text-xs"></i>
            </button>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-950'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl text-foreground-800`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className={`block px-3 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === '/' ? 'bg-primary-100 text-primary-700' : 'text-foreground-700'
              }`}
            >
              首页
            </Link>
            {categories.filter((c) => c.slug !== 'all').map((cat) => (
              <button
                key={cat.slug}
                onClick={() => handleCategoryClick(cat.slug)}
                className={`block w-full text-left px-3 py-2.5 rounded-lg text-sm font-medium ${
                  location.pathname.includes(`/category/${cat.slug}`)
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-700'
                }`}
              >
                {cat.name}
              </button>
            ))}
            <Link
              to="/about"
              className={`block px-3 py-2.5 rounded-lg text-sm font-medium ${
                location.pathname === '/about' ? 'bg-primary-100 text-primary-700' : 'text-foreground-700'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}